import { Outlet } from 'react-router-dom'

export const Inventory = () => {
  return <Outlet />
}
